import parse from "html-react-parser";

/**
 * Parse WordPress Posts
 *
 * WordPress REST API returns encoded unicode characters and html markup.
 * This function transforms that data into usable content.
 *
 * @param rawData
 * @returns {*[]}
 */
export const parseWordpressPosts = (rawData) => {
    let filteredData = []
    rawData.forEach((post) => {
        post.title.rendered = parse(post.title.rendered)
       // post.excerpt.rendered = parse(post.excerpt.rendered)
        post.author_name = parse(post.author_name)
        post.date_formatted = formatDate(post.date, {
            month: "long",
            day: "numeric",
            year: "numeric"
        })
        filteredData.push(post)
    })
    return filteredData
}

/**
 * Build Request URL
 *
 * Builds the WordPress REST API url for the given parameters.
 *
 * @param args
 * @returns {string|*}
 */
export const buildRequestURL = (args = {}) => {

    if ( typeof args.apiDomain === 'undefined' || typeof args.apiPath === 'undefined' ) {
        return ''
    }

    let url = args.apiDomain + args.apiPath
    let queryArgs = []

    if ( typeof args.perPage !== 'undefined' && args.perPage !== '') {
        queryArgs.push('per_page=' + args.perPage)
    }

    if ( typeof args.offset !== 'undefined' && args.offset !== '') {
        queryArgs.push('offset=' + args.offset)
    }

    if ( typeof args.orderby !== 'undefined' && args.orderby !== '') {
        queryArgs.push('orderby=' + args.orderby)
    }

    if ( typeof args.order !== 'undefined' && args.order !== '') {
        queryArgs.push('order=' + args.order)
    }

    if ( queryArgs.length > 0 ) {
        url = url + '?' + queryArgs.join('&')
    }

    return url
}

/**
 * Convert date format from WordPress standard to pretty output
 *
 * @param date
 * @param format
 * @returns {string}
 */

export const formatDate = (date, format) => {
    const dateObject = new Date(date)
    return dateObject.toLocaleDateString("en-GB", format)
}

/**
 * Get query params from URL
 */

export const queryParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});